export const text = {
  CANCEL: 'Cancel',
  NEXT: 'Next',
  NEW_VISIT: 'New visit',
  PREVIOUS: 'Previous',
  BOOK_VISIT: 'Book visit',
  RESCHEDULE_VISIT: 'Reschedule visit',
  SAVE_CHANGES: 'Save changes',
  BACK: 'Back',
}

export const buttonTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
}

export const styles = {
  BUTTON_CONTAINER_STYLE: {
    width: 200,
    height: 40,
    boxSizing: 'border-box',
  },
  LABEL_STYLE: {
    fontSize: 20,
    fontWeight: 700,
  },
}
